import dateFormat, { masks } from "dateformat";

export function formatDate(d, format = "dd/mm/yy"){
    var date = new Date(d);
    return dateFormat(date, format);
}